export default {
  ACQUISITION(state, items) {
    state.items = items;
  }
};
